import { jsx as _jsx } from "react/jsx-runtime";
import { Dropdown as BootstrapDropdown } from 'react-bootstrap';
export const DropdownItem = props => (_jsx(BootstrapDropdown.Item, Object.assign({ onClick: props.onClick, className: props.className }, { children: props.children })));
